import React, {
  useContext, useEffect, useState,
} from 'react';
import { CollectionSettingsDataContext } from '../contextProvider';
import { useSpaceAndPageIDFromRouter } from '../../../../../data/space/hooks';
import { useGetSpaceQuery } from '../../../../../store';

function Customize({ id }: {id: string}) {
  const [iframeLoading, setiframeLoading] = useState(true);
  const [spaceID, pageID] = useSpaceAndPageIDFromRouter();
  const { element } = useContext(CollectionSettingsDataContext);
  const { data: space } = useGetSpaceQuery([spaceID]);
  const [currentOrigin, setCurrentOrigin] = useState('');
  useEffect(() => {
    if (typeof window === 'undefined') return;
    setCurrentOrigin(window?.location?.origin || '');
  }, []);
  return (
    <div style={{
      width: 'calc(100% - 20px)',
      height: 'calc(min(800px, 90vh) - 210px)',
      boxShadow: 'var(--shadow-navbar)',
      border: '1px solid var(--border-modal)',
      borderRadius: 10,
      overflow: 'hidden',
      marginRight: 20,
    }}
    >
      <iframe
        id={id}
        title="preview title"
        src={`${currentOrigin}/s/${space?.slug}/${spaceID}/${pageID}/ct/${element?.id}`}
        height="100%"
        width="100%"
        style={{ borderRadius: 10, height: '100%' }}
        onLoad={() => setiframeLoading(false)}
      />
      {iframeLoading
        ? (
          <div className="loader-small-wrapper">
            <div className="loader-box-big has-fit-content-width">
              <div className="loader-big loader is-loading with-accent-border-color" />
            </div>
          </div>
        ) : null}
    </div>
  );
}

export default Customize;
